import { workerService } from '@/services';
import { mutationType } from './mutations';
const actions = {
    setFilterOption({ commit }, payload) {
        commit(mutationType.SET_FILTER_OPTION, payload);
    },
    setSortOption({ commit }, payload) {
        commit(mutationType.SET_SORT_OPTION, payload);
    },
    async getWorkerList({ state: { filterOption, sortOption }, getters, commit, rootGetters, }) {
        try {
            // 1.3.0 기준으로 백엔드에서 총판조회 기능이 없다. 이에 isHubSelected 해당 기능은 의미가 없다.
            // 추후 추가될 기능이므로 구현만 해두고, 허브셀렉트 박스에서 총판 선택 기능을 막는 것으로 배포한다.(pageType3)
            // 추후 총판 내 라이더 조회가 가능해지면 pageType1으로 허브셀렉트 박스만 오픈하면 된다.(23.5.22. 하준)
            const isHubSelected = rootGetters['hubSelector/getterIsSubscribeHub'];
            const hubId = isHubSelected ? rootGetters['hubSelector/getterSubscribeHubId'] : null;
            const { pageNumber, pageSizeType } = filterOption;
            // 필터
            const filters = [];
            // 검색
            filters.push(...getters.getterSearchFieldTypeParam);
            // 상태
            filters.push(...getters.getterWorkerStatus);
            const pageSize = Number(pageSizeType);
            const param = {
                pageNumber,
                pageSize,
                hubId,
                filters,
                sortOption,
            };
            const data = await workerService.getWorkerListOnly(param);
            commit(mutationType.GET_WORKER_LIST, data);
        }
        catch (error) {
            console.log('[getWorker]', error);
        }
    },
};
export default actions;
